import { whatsappIntegrationDisplayLabel } from "@/lib/whatsapp-integration-label";
import type { MessagingChannel } from "@/lib/messaging-integration-providers";

export type MessagingIntegrationOption = {
  id: string;
  provider: string;
  config: Record<string, unknown> | null;
  instance_identifier: string | null;
  instagram_account_id: string | null;
  page_id: string | null;
  status: string | null;
};

function getConfigString(config: MessagingIntegrationOption["config"], key: string): string {
  const value = config?.[key];
  return typeof value === "string" ? value : "";
}

export function getMessagingIntegrationLabel(integration: MessagingIntegrationOption): string {
  if (
    integration.provider === "whatsapp_evolution" ||
    integration.provider === "whatsapp_cloud" ||
    integration.provider === "whatsapp_uazapi"
  ) {
    return whatsappIntegrationDisplayLabel(
      {
        instance_identifier: integration.instance_identifier,
        provider: integration.provider,
        config: {
          friendly_name: getConfigString(integration.config, "friendly_name") || null,
          instance_name:
            getConfigString(integration.config, "instanceName") ||
            getConfigString(integration.config, "instance_name") ||
            null,
          phone_number:
            getConfigString(integration.config, "phone_number") ||
            getConfigString(integration.config, "phone") ||
            null,
          display_phone_number: getConfigString(integration.config, "display_phone_number") || null,
          verified_name: getConfigString(integration.config, "verified_name") || null,
        },
      },
      "WhatsApp",
    );
  }

  if (integration.provider === "instagram") {
    const username = getConfigString(integration.config, "instagram_username");
    if (username) return `@${username}`;
    return getConfigString(integration.config, "page_name") || "Instagram";
  }

  if (integration.provider === "messenger") {
    return getConfigString(integration.config, "page_name") || "Messenger";
  }

  return integration.provider;
}

export function getMessagingIntegrationDetail(integration: MessagingIntegrationOption): string {
  if (
    integration.provider === "whatsapp_evolution" ||
    integration.provider === "whatsapp_cloud" ||
    integration.provider === "whatsapp_uazapi"
  ) {
    const config = integration.config;
    if (integration.provider === "whatsapp_cloud") {
      return (
        getConfigString(config, "verified_name") ||
        getConfigString(config, "display_phone_number") ||
        ""
      );
    }
    return getConfigString(config, "phone") || getConfigString(config, "number") || "";
  }

  if (integration.provider === "instagram") {
    return getConfigString(integration.config, "instagram_name");
  }

  if (integration.provider === "messenger") {
    return "";
  }

  return "";
}

export function groupMessagingIntegrationsByChannel(
  integrations: MessagingIntegrationOption[],
): Record<MessagingChannel, MessagingIntegrationOption[]> {
  const grouped: Record<MessagingChannel, MessagingIntegrationOption[]> = {
    whatsapp: [],
    instagram: [],
    messenger: [],
  };

  for (const integration of integrations) {
    if (
      integration.provider === "whatsapp_evolution" ||
      integration.provider === "whatsapp_cloud" ||
      integration.provider === "whatsapp_uazapi"
    ) {
      grouped.whatsapp.push(integration);
    } else if (integration.provider === "instagram") {
      grouped.instagram.push(integration);
    } else if (integration.provider === "messenger") {
      grouped.messenger.push(integration);
    }
  }

  return grouped;
}
